import mobFeatDoc from "../assets/images/mob_feat_org.png";
import mobFeatConf from "../assets/images/mob_feat_conf.png";
import mobFeatAhead from "../assets/images/mob_feat_ahead.png";

export const mobileFeature = [
    {
      title: "Organize Everything in One Place",
      para1: "Securely store and categorize all your personal, family, and pet documents in one digital vault.",
      para2: "From passports and IDs to bank details, property papers, and other documents, everything is accessible and always at your fingertips.",
      bgClass: "mob-feat-bg-",
      image: mobFeatDoc,
    },
    {
      title: "Share with Confidence",
      para1: "Effortlessly share selected documents via time-sensitive, trackable links, anytime, anywhere, with full control.",
      para2: "Whether applying for a job or sending legal paperwork, DOXBOX ensures smooth, secure document sharing with built-in expiry dates and privacy settings.",
      bgClass: "mob-feat-bg-",
      image: mobFeatConf,
    },
    {
      title: "Stay Ahead",
      para1: "Get smart alerts before documents expire and unlock tools for connection.",
      para2: "Never miss a renewal again, and take advantage of built-in features like smart business card with QR code to elevate your personal brand.",
      bgClass: "mob-feat-bg-",
      image: mobFeatAhead,
    },
  ];
